/** NOTIF1 T13: inbox (computed actions) + notification feed. Mirrors backend config/inbox_rules.py. */
export const NOTIFICATIONS_PATH = '/notifications';
/** Agenda deep link from the teacher email: /schedules?request=<schedule_request id> (T19). */
export const REQUEST_PARAM = 'request';

export const INBOX_API = Object.freeze({
  SNAPSHOT: '/inbox/snapshot',
  SUMMARY: '/inbox/summary',
  ACTIONS: '/inbox/actions',
  SNOOZE: (key) => `/inbox/actions/${encodeURIComponent(key)}/snooze`,
  DISMISS: (key) => `/inbox/actions/${encodeURIComponent(key)}/dismiss`,
  NOTIFICATIONS: '/notifications',
  NOTIFICATIONS_READ: '/notifications/read',
  DECISION: (requestId) => `/family-space/teacher/schedule-requests/${requestId}/decision`,
});

export const PRIORITY = Object.freeze({ URGENT: 1, DECISION: 2, SUGGESTION: 3 });

export const ACTION_TYPE = Object.freeze({
  CANCEL_REQUEST: 'cancellation_request',
  LESSON_REQUEST: 'lesson_request',
  SCHEDULE_CONFLICT: 'schedule_conflict',
  URSSAF_DECLARATION: 'urssaf_declaration',
  URSSAF_PAYMENT_ISSUE: 'urssaf_payment_issue',
  SUGGESTION: 'suggestion',
  URSSAF_DEMAND_RETRY: 'urssaf_demand_retry',
});

/** Ops the server allows on an action (`action.actions`). */
export const OP = Object.freeze({ DECIDE: 'decide', SNOOZE: 'snooze', DISMISS: 'dismiss' });

/** Decision verbs: POST …/decision body (backend SCHEDULE_REQUEST_DECISIONS) and notification `item.actions`. */
export const DECISION = Object.freeze({ APPROVE: 'approve', REJECT: 'reject' });

/** Family event types written to `notifications` (backend family_space_defaults ACTION_*). */
export const EVENT_TYPE = Object.freeze({
  LESSON_REQUEST: 'lesson_request',
  CANCEL_REQUEST: 'cancel_request',
  AI_SENT: 'ai_sent',
  AI_CAP: 'ai_cap',
  AI_FAILED: 'ai_failed',
  AI_CHILDREN: 'ai_children',
  IDENTITY_EMAIL: 'identity_email',
  MEMO_SET: 'memo_set',
  DATA_DELETION: 'data_deletion_request',
  // N30: written for teacher AND family, even the actor's own row.
  LESSON_REGISTERED: 'lesson_registered',
  PAYMENT_REGISTERED: 'payment_registered',
  // DEL1 R5: teacher deleted / cancelled / edited → both sides get a row.
  LESSON_DELETED: 'lesson_deleted',
  LESSON_CANCELLED: 'lesson_cancelled',
  PAYMENT_CANCELLED: 'payment_cancelled',
  PAYMENT_UPDATED: 'payment_updated',
  // REC1: teacher skipped / moved the next séance from the record → both sides get a row.
  SESSION_SKIPPED: 'session_skipped',
  SESSION_MOVED: 'session_moved',
  // URS1 « Plus tard »: the parent still has to validate the URSSAF e-mail. Both sides, never signed.
  URSSAF_VALIDATION_PENDING: 'urssaf_validation_pending',
  // URS2 « Réessayer demain »: teacher-only row; the inbox action follows the next morning.
  URSSAF_DEMAND_RETRY: 'urssaf_demand_retry',
});
export const REGISTRATION_EVENTS = Object.freeze([EVENT_TYPE.LESSON_REGISTERED, EVENT_TYPE.PAYMENT_REGISTERED,
  EVENT_TYPE.LESSON_DELETED, EVENT_TYPE.LESSON_CANCELLED, EVENT_TYPE.PAYMENT_CANCELLED, EVENT_TYPE.PAYMENT_UPDATED,
  EVENT_TYPE.SESSION_SKIPPED, EVENT_TYPE.SESSION_MOVED,
  EVENT_TYPE.URSSAF_VALIDATION_PENDING, EVENT_TYPE.URSSAF_DEMAND_RETRY]);

/** N31: poll while a tab is open (no SSE, N8); browser pop-up opt-in key (per browser). */
export const NEW_EVENTS_POLL_MS = 30000;
export const TEACHER_BROWSER_OPT_IN_KEY = 'np_browser_notifications';

export const REQUEST_STATE = Object.freeze({ PENDING: 'pending', APPROVED: 'approved', REJECTED: 'rejected' });

export const SNOOZE_DAYS = Object.freeze([1, 3, 7]);

export const BELL_ACTIONS_MAX = 3;
export const BELL_EVENTS_MAX = 8;
export const BADGE_MAX = 9;
export const FEED_PAGE_SIZE = 20;

/** Filter chips on /notifications: action types + event types per chip. Empty = all. */
export const INBOX_FILTER = Object.freeze({ ALL: 'tout', CANCELS: 'annulations', REQUESTS: 'demandes', PAYMENTS: 'paiements', URSSAF: 'urssaf' });
export const INBOX_FILTERS = Object.freeze([
  { id: INBOX_FILTER.ALL, actionTypes: [], eventTypes: [] },
  { id: INBOX_FILTER.CANCELS, actionTypes: [ACTION_TYPE.CANCEL_REQUEST], eventTypes: [EVENT_TYPE.CANCEL_REQUEST] },
  { id: INBOX_FILTER.REQUESTS, actionTypes: [ACTION_TYPE.LESSON_REQUEST], eventTypes: [EVENT_TYPE.LESSON_REQUEST] },
  { id: INBOX_FILTER.PAYMENTS, actionTypes: [ACTION_TYPE.URSSAF_PAYMENT_ISSUE],
    eventTypes: [EVENT_TYPE.AI_SENT, EVENT_TYPE.AI_CAP, EVENT_TYPE.AI_FAILED, EVENT_TYPE.AI_CHILDREN, EVENT_TYPE.PAYMENT_REGISTERED] },
  { id: INBOX_FILTER.URSSAF, actionTypes: [ACTION_TYPE.URSSAF_DECLARATION, ACTION_TYPE.URSSAF_PAYMENT_ISSUE],
    eventTypes: [EVENT_TYPE.AI_SENT, EVENT_TYPE.AI_FAILED] },
]);

/** Where an action's primary link goes. Suggestions: by smart type, else Accueil. */
export const ACTION_TARGET = Object.freeze({
  [ACTION_TYPE.SCHEDULE_CONFLICT]: '/schedules',
  [ACTION_TYPE.URSSAF_DECLARATION]: '/statistics',
  [ACTION_TYPE.URSSAF_PAYMENT_ISSUE]: '/statistics',
});
/** Official hosts a backend `meta.nav.url` may open in a new tab (fiscal deadlines). */
export const EXTERNAL_TARGET_HOSTS = Object.freeze(['www.impots.gouv.fr']);
export const SUGGESTION_TARGET = Object.freeze({
  complete_profile: '/parametres/profil',
  credentials: '/parametres/urssaf',
  add_first_family: '/families/add',
  add_first_student: '/students/add',
});
export const SUGGESTION_FALLBACK_TARGET = '/home';
